
import { tables } from "@/lib/supabase";
import { handleError, ErrorSeverity, ErrorContext } from "@/utils/errorHandler";
import { Payment } from "../types";

export const PaymentRecordService = {
  /**
   * Create a new payment record
   */
  createPayment: async (
    familyId: string,
    organizationId: string,
    amountCents: number,
    stripePaymentIntent: string,
    status: string,
    receiptUrl: string
  ): Promise<Payment | null> => {
    const context: ErrorContext = {
      operation: "createPayment",
      additionalInfo: { familyId, organizationId },
    };

    try {
      const paymentData = {
        family_id: familyId,
        organization_id: organizationId,
        amount_cents: amountCents,
        stripe_payment_intent: stripePaymentIntent,
        status: status,
        receipt_url: receiptUrl,
      };

      const { data, error } = await tables.payments()
        .insert(paymentData)
        .select()
        .single();

      if (error) throw error;
      return data as any;
    } catch (error) {
      handleError(error, "Failed to create payment", ErrorSeverity.ERROR, context);
      return null;
    }
  }
};
